import { Button, Icon, Text, Tooltip, VStack } from '@chakra-ui/react';
import { Heart, HeartFilled } from '../../assets';
import { getDataTracking } from '../../utils';

interface DonationThankedProps {
  name: string;
  thanked: boolean;
  onSayThanks: () => void;
}
export const DonationThanked = (props: DonationThankedProps): JSX.Element => {
  const { thanked, onSayThanks, name } = props;

  return (
    <Tooltip label={!thanked ? `Mark all gifts from ${name} as thanked` : ''}>
      <VStack minW="69px" spacing={2}>
        {!thanked && (
          <>
            <Icon
              as={Heart}
              color="brand.primary.swatch1"
              boxSize="24px"
              onClick={() => onSayThanks()}
              _hover={{ cursor: 'pointer' }}
              {...getDataTracking('sayThanksModalButton')}
            />
            <Button
              color="brand.primary.swatch1"
              variant="link"
              fontSize="xs"
              fontWeight="800"
              onClick={() => onSayThanks()}
              {...getDataTracking('sayThanksModalButton')}
            >
              Say Thanks
            </Button>
          </>
        )}
        {thanked && (
          <>
            <Icon
              as={HeartFilled}
              color="brand.additional.link"
              boxSize="24px"
            />
            <Text color="brand.additional.link" fontSize="xs" fontWeight="800">
              Thanked
            </Text>
          </>
        )}
      </VStack>
    </Tooltip>
  );
};
